import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';

import { Skeleton } from '@/components/ui/skeleton';
import { AdminOrganisationsCard } from '@/features/organisations/components/admin-organisations-card';
import { AdminManagedSuppliersCard } from '@/features/suppliers/components/admin-managed-suppliers-card';

function AdminPage() {
  return (
    <div className="container mx-auto p-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold">Admin Dashboard</h1>
        <p className="text-gray-600">System overview and management</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Suspense fallback={<Skeleton className="h-24 w-full" />}>
          <AdminOrganisationsCard />
        </Suspense>

        <Suspense fallback={<Skeleton className="h-24 w-full" />}>
          <AdminManagedSuppliersCard />
        </Suspense>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/admin/')({
  component: AdminPage,
});
